export var eargoBaseUrl = process.env.REACT_APP_EARGO_BASE_URL || '';
